export const diseaseCommon = {
  ganyanoptions: ['无', '甲肝', '乙肝', '丙肝'],
  jieheoptions:['无', '肺结核', '盆腔结核'],
  xinxueguanoptions:['无', '高血压', '心脏病'],
  xingjibingoptions:['无', '艾滋病', '梅毒'],
};
export const  nation = [
  {key:'01',value:'汉族'},
  {key:'02',value:'蒙古族'},
  {key:'03',value:'回族'},
  {key:'04',value:'藏族'},
  {key:'05',value:'维吾尔族'},
  {key:'06',value:'苗族'},
  {key:'07',value:'彝族'},
  {key:'08',value:'壮族'},
  {key:'09',value:'布依族'},
  {key:'10',value:'朝鲜族'},
  {key:'11',value:'满族'},
  {key:'12',value:'侗族'},
  {key:'13',value:'瑶族'},
  {key:'14',value:'白族'},
  {key:'15',value:'土家族'},
  {key:'16',value:'哈尼族'},
  {key:'17',value:'哈萨克族'},
  {key:'18',value:'傣族'},
  {key:'19',value:'黎族'},
  {key:'20',value:'傈僳族'},
  {key:'21',value:'佤族'},
  {key:'22',value:'畲族'},
  {key:'23',value:'高山族'},
  {key:'24',value:'拉祜族'},
  {key:'25',value:'水族'},
  {key:'26',value:'东乡族'},
  {key:'27',value:'纳西族'},
  {key:'28',value:'景颇族'},
  {key:'29',value:'柯尔克孜族'},
  {key:'30',value:'土族'},
  {key:'31',value:'达斡尔族'},
  {key:'32',value:'仫佬族'},
  {key:'33',value:'羌族'},
  {key:'34',value:'布朗族'},
  {key:'35',value:'撒拉族'},
  {key:'36',value:'毛南族'},
  {key:'37',value:'仡佬族'},
  ];
export const education = [
  {key:'01',value:'博士研究生'},
  {key:'02',value:'硕士研究生'},
  {key:'03',value:'本科毕业'},
  {key:'04',value:'本科结业'},
  {key:'05',value:'专科毕业生'},
  {key:'06',value:'其他'},
];



// WEBPACK FOOTER //
// ./src/api/diseaseCommon.js